import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { actions } from 'Data/ReduxViewModels/WorksheetEditor';
import { pipe } from 'Lib/Hooks/Selectors';
import { valueOrDefault } from 'Lib/Any';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { IncrementRecordRowDefinition, LoadIncrementReading } from 'Components/Worksheets/PlateLoadingWorksheet/types';
import deepEquals from 'Lib/Object/deepEquals';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { max } from 'lodash';
import IncrementReadingsGridSection from './IncrementReadingsGridSectionBase';

let LoadIncrementReadingsGridSectionBase: React.FC<IWorksheetComponent> = ({ namePrefix, createWorksheetSelector }) => {
  const dispatch = useDispatch();

  const recordRows: IncrementRecordRowDefinition[] = useSelector(
    pipe(createWorksheetSelector!('Readings'), valueOrDefault([]), (records: LoadIncrementReading[]) => {
      return records.map((record, index) => ({
        ElapsedTime: record.ElapsedTime,
          GaugeReading1: record.GaugeReading1,
          GaugeReading2: record.GaugeReading2,
          GaugeReading3: record.GaugeReading3,
        AverageSettlment: record.AverageSettlement,
        index,
      }));
    }),
    deepEquals
  );

  return (
    <IncrementReadingsGridSection
      name="Readings"
      readingName={(i) => `Readings[${i}]`}
      readings={recordRows}
      onCreateRow={() =>
        dispatch(
          actions.addArrayEntry({
            name: `${namePrefix}.Readings`,
            index: recordRows.length ?? 0,
            data: {
              ElapsedTime: {
                uom: 'min',
                value: (max(recordRows.map((r) => Number(r.ElapsedTime?.value))) ?? 0) + 1,
              },
            },
            sync: true,
          })
        )
      }
      onRemoveRow={(i: number) =>
        dispatch(actions.removeArrayEntry({ name: `${namePrefix}.Readings`, index: i, sync: true }))
      }
    />
  );
};

const LoadIncrementReadingsGridSection = withInjectedProps(LoadIncrementReadingsGridSectionBase);

export { LoadIncrementReadingsGridSection };
export default LoadIncrementReadingsGridSection;
